module.exports = __webpack_public_path__ + "img/1157022705.ed6a3a7a.jpg";